<template>

  <div>
    <div
      class="item-header"
      @click="toggleContent"
    >
      <slot
        name="header"
        v-bind:showContent="showContent"
      ></slot>
    </div>
    <transition name="accordion">
      <div
        v-if="showContent"
        class="item-content"
        :class="{'shown' : showContent}"
      >
        <slot
          name="tab"
          v-bind:showContent="showContent"
        ></slot>
        <slot
          name="content"
          v-bind:showContent="showContent"
        ></slot>
      </div>
    </transition>
  </div>

</template>

<script>
export default {
  name: 'CollapsableItem',
  props: {
    display: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showContent: false
    }
  },
  methods: {
    toggleContent () {
      this.showContent = !this.showContent
      this.$emit('collapse', this.showContent)
    }
  },
  created () {
    if (this.display) {
      this.showContent = true
    }
  }

}
</script>

<style scoped>
.item-content {
  margin-bottom: 10px;
}
</style>
